import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed, data } = useRequest({
    url: '/api/system/login',
    name: 'POST_LOGIN',
    method: 'POST',
  });

  return [exec, isRequestSuccessed, data];
});
